@if (isThemeLight) {
  <div class="tooltip-arrow"></div>
}

@if (options['contentType'] === 'template') {
  <div>
    <ng-container *ngTemplateOutlet="value"></ng-container>
  </div>
} @else {
  <div [innerHTML]="value"></div>
}

